// src/index.ts
import { assert as _assert } from "rattail";
export * from "rattail";
function assert(condition, source, message) {
  return _assert(condition, `Varlet [${source}]: ${message}`);
}
function warn(source, message) {
  console.warn(`Varlet [${source}]: ${message}`);
}
function error(source, message) {
  console.error(`Varlet [${source}]: ${message}`);
}
var isURL = (val) => {
  if (!val) {
    return false;
  }
  return /^(http)|(\.*\/)/.test(val);
};
export {
  assert,
  error,
  isURL,
  warn
};
